import type { OilViscosityCalculator } from "../../d";
import { deadOilViscosityCalculator } from "./deadOilViscosityCalculator";
import { saturatedOilViscosityCalculator } from "./saturatedOilViscosityCalculator";
import { underSaturatedOilViscosityCalculator } from "./underSaturatedOilViscosityCalculator";

const oilViscositiesCalculator: OilViscosityCalculator = {
  deadOilViscosityCalculator,
  saturatedOilViscosityCalculator,
  underSaturatedOilViscosityCalculator
};

export { oilViscositiesCalculator };
